import ImageLayer  from "ol/layer/Image.js"
import ImageWMS from 'ol/source/ImageWMS.js';
import TileLayer from "ol/layer/Tile.js"
import TileWMS from 'ol/source/TileWMS.js';

import {urlGeoserver} from "./globals";

const materiaux =[
    {"id": "Toutes les valorisations","nom":"Toutes les valorisations","active" : true},
    {"id": "Pierre de taille","nom":"Pierre de taille","active" : false},
    {"id": "Pierre de remblais","nom":"Pierre de remblais","active" : false},
    {"id": "Pierre de construction","nom":"Pierre de construction","active" : false},
    {"id": "Pierre d'aménagement intérieur","nom":"Pierre d'aménagement intérieur","active" : false},
];


const geologieFiltreWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:geologie_agg_lito',
            'TILED': true,
            'STYLE':'geologie_lito_presence_argile',
            'VERSION':'1.1.1'
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:0.5,
    visible:false,
    title:"Géologie"
});

const carriereWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:carrieres',
            'TILED': true,
            'STYLES':'carrieres_statut'
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:1,
    visible:false,
    title:"Carrières"
});

export const paramGeologieRepresentation = [
    {"id":"geologie_agg_lito","nom":"Lithologie","styles":"geologie_lito_presence_argile"},
    {"id":"geologie_agg_matiere","nom":"Matière","styles":"geologie_mat_presence_argile"}
]


export const paramCarriereRepresentation = [
    {"id":"carrieres_statut","nom":"Autorisation d'exploiter"},
    {"id":"carrieres_substrat_principal","nom":"Matériau principal"}
]

export const geologieFiltreWmsLayer = geologieFiltreWmsLayer0;
export const carriereWmsLayer=carriereWmsLayer0;
export const geologieProperties = materiaux;